import React, { Component } from 'react';
import './mainButton.css'

class MainButton extends Component {

  state = {
    className: `main-button ${this.props.additionalClassName}`
  }

  render() {
    return(
      <div className={this.state.className} onClick={() => this.props.action()}>
        {this.props.label}
      </div>
    )
  }
}

export default MainButton;
